import cn from 'classnames';
import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { IImage } from 'tbk-components/src/components/Image';
import SocialIcons, {
	ISocialIconsProps,
} from 'tbk-components/src/components/SocialIcons';

export interface IFollowUsProps extends IBaseElementProps {
	image?: IImage;
	imageHeight?: number;
	imageWidth?: number;
	heading?: string;
	text?: string;
	socialIcons?: ISocialIconsProps;
	socialIconsColour?: 'default' | 'blue' | 'white';
}

/**
 * Follow Us
 * @block
 * @requiresHooks
 * @icon networking
 */
const FollowUs: React.FC<IFollowUsProps> = ({
	className,
	classNames = [],
	image,
	imageHeight,
	imageWidth,
	heading,
	text,
	socialIcons,
	socialIconsColour = 'default'
}) => (
	<div
		className={cn(
			'follow-us', ...classNames,
			`follow-us--icons-colour-${socialIconsColour}`,
		)}
	>
		{image && (
			<img
				src={image.src}
				alt={image.alt}
				width={image.width}
				height={image.height}
				className="follow-us__image"
				style={
					imageHeight && imageWidth
					? {
						width: `${imageWidth}px`,
						height: `${imageHeight}px` }
					: {}
				}
			/>
		)}

		{heading && <h2 className="follow-us__heading">{heading}</h2>}
		{text && <div className="follow-us__text">{text}</div>}
		{socialIcons && <SocialIcons {...socialIcons} />}
	</div>
);

export default FollowUs;
